
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(353|397|425|710)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
